var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Image } from './styled';
import { PhotoSlider } from "../../../../components/react-photo-view";
import "../../../../components/react-photo-view/Photo";
import PhotoPage from "../../../../components/react-photo-view/PhotoPage";
import "../../../../components/react-photo-view/PhotoSlider";
import { Box, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import { useCallback, useState } from 'react';
var BodyImages = function (_a) {
    var reviewImgs = _a.reviewImgs;
    var _b = __read(useState(false), 2), visible = _b[0], setVisible = _b[1];
    var _c = __read(useState(0), 2), index = _c[0], setIndex = _c[1];
    var handleSelected = useCallback(function (_, i) {
        setIndex(i);
        setVisible(true);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Stack, __assign({ spacing: 2, direction: "row" }, { children: reviewImgs === null || reviewImgs === void 0 ? void 0 : reviewImgs.map(function (_a, i) {
                    var url = _a.url, title = _a.title;
                    return (_jsxs(Stack, __assign({ spacing: 0.5, onClick: function () {
                            setIndex(i);
                            setVisible(true);
                        } }, { children: [_jsx(Image, { src: url, alt: "" }), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary", textAlign: "center" }, { children: title }))] }), url));
                }) })), _jsx(PhotoSlider, { maskOpacity: 0.56, visible: visible, onClose: function () { return setVisible(false); }, index: index, onIndexChange: setIndex, images: reviewImgs === null || reviewImgs === void 0 ? void 0 : reviewImgs.map(function (item) { return ({ src: item.url, key: item.url, title: item === null || item === void 0 ? void 0 : item.title }); }), overlayRender: function (_a) {
                    var images = _a.images, index = _a.index;
                    return (_jsx(Box, __assign({ sx: { width: 1, position: 'absolute', bottom: 0, zIndex: 50 } }, { children: _jsx(PhotoPage, { onSelected: handleSelected, images: images, index: index }) })));
                } })] }));
};
export default BodyImages;
